// Pure CSS infinite marquee. `reverse` flips direction.
const Marquee = ({ text, reverse = false, bg = "bg-lime", color = "text-ink" }) => {
  const items = Array.from({ length: 4 });
  return (
    <div className={`relative overflow-hidden ${bg} border-b border-ink py-2.5 md:py-3`} data-testid="marquee">
      <div className={`flex whitespace-nowrap ${reverse ? "animate-marquee-reverse" : "animate-marquee"}`}>
        {items.map((_, i) => (
          <span key={i} className={`display ${color} text-xl md:text-3xl uppercase px-4 flex-shrink-0`}>
            {text}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
